module.exports = __webpack_public_path__ + "img/ios-install-step-2.9e992bff.svg";